import popoverTheme from '../popover.theme';

const interactionStates = {
  none: popoverTheme.closeButtonBackground,
  hover: popoverTheme.closeButtonHoverColor,
  active: popoverTheme.closeButtonActiveColor,
  noneInverse: popoverTheme.closeButtonBackground,
  hoverInverse: popoverTheme.closeButtonHoverInverseColor,
  activeInverse: popoverTheme.closeButtonActiveInverseColor,
};

export default (interactionState, inverse) =>
  interactionStates[`${interactionState}${inverse ? 'Inverse' : ''}`];
